import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { PricingCards } from "../components/PricingCards";

export default function Pricing() {
  return (
    <div className="min-h-screen px-4 md:px-6 py-10">
      <div className="max-w-6xl mx-auto fade-in">
        <Link to="/" data-testid="pricing-back-link" className="flex items-center gap-1 text-sm text-[#16233D]/60 mb-6"><ArrowLeft size={16} /> Retour au site</Link>
        <p className="font-display font-bold text-3xl lowercase tracking-tight">kavizio</p>
        <h1 className="font-display font-bold text-3xl sm:text-4xl tracking-tight mt-4">Nos offres</h1>
        <p className="text-[#16233D]/65 mt-2 mb-9 max-w-2xl">
          Payez pour la taille de votre équipe, pas pour des fonctions que vous n'utilisez pas.
          Vous changez d'offre quand vous voulez : les nouveaux modules apparaissent immédiatement, sans perte de données.
        </p>
        <PricingCards />
        <p className="text-sm text-[#16233D]/60 mt-8">
          Une question sur l'offre adaptée à votre structure ? <Link to="/contact" className="text-[#C9793A] font-semibold">Écrivez-nous</Link>.
        </p>
      </div>
    </div>
  );
}
